module.exports = __webpack_public_path__ + "img/KP.905f3f2e.svg";